import { render, staticRenderFns } from "./RowTextarea.vue?vue&type=template&id=60e8051a&"
import script from "./RowTextarea.vue?vue&type=script&lang=js&"
export * from "./RowTextarea.vue?vue&type=script&lang=js&"
import style0 from "./RowTextarea.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
